import { ChevronLeft } from '@mui/icons-material'
import { Button, Grid, Typography, TypographyProps } from '@mui/material'
import { useNavigate } from 'react-router'

type PageTitleProps = TypographyProps & {
  noMarginBottom?: boolean
  subTitle?: string
  actions?: React.ReactNode[]
  showBackButton?: boolean
}
export const PageTitle = ({
  variant,
  children,
  noMarginBottom,
  subTitle,
  showBackButton,
  actions,
  ...props
}: PageTitleProps) => {
  const navigate = useNavigate()
  const marginBottom = noMarginBottom ? 0 : 2
  return (
    <Grid container sx={{ mb: marginBottom, justifyContent: 'space-between' }}>
      <Grid size="grow">
        <Typography variant={variant || 'h1'} {...props}>
          {children}
        </Typography>
        {subTitle && <Typography variant="h2">{subTitle}</Typography>}
      </Grid>
      <Grid container spacing={2} sx={{ position: 'relative', alignContent: 'center', justifyContent: 'flex-end' }}>
        {actions &&
          actions.length > 0 &&
          actions?.map((action, index) => (action === undefined ? null : <Grid key={index}>{action}</Grid>))}
        {showBackButton && (
          <Grid size="auto">
            <Button startIcon={<ChevronLeft />} variant="outlined" color="secondary" onClick={() => navigate(-1)}>
              Back
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}
